import { memo, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

import FloatButton from '@hapana/shared/web/components/shared/float-button/float-button.component'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import useSiteStore from '_stores/site.store'

import ModalCheckIn from '@components/check-in-widget/modal-check-in/modal-check-in.component'
import { useEquipmentFCMAlerts } from '_hooks/use-equipment-fcm-alerts'

// Paths where the check-in button should be hidden
const HIDDEN_PATHS = ['/login', '/location-selection', '/select-location']

const CheckInFloatingButton = memo(() => {
  const { currentSite } = useSiteStore()
  const location = useLocation()
  const { pushDialog, dialogState } = useDialog()

  useEquipmentFCMAlerts()

  const [checkInCounter, setCheckInCounter] = useState(0)
  const [newCheckIn, setNewCheckIn] = useState({})

  const dialogStateRef = useRef(dialogState)
  useEffect(() => {
    dialogStateRef.current = dialogState
  }, [dialogState])

  useEffect(() => {
    const channel = new BroadcastChannel('fcm-notifications')

    channel.onmessage = (event) => {
      const { type, data } = event.data || {}
      if (type !== 'FCM_NOTIFICATION') return

      const notificationData = data?.data || data
      if (notificationData?.type === 'CHECK_IN_CREATED') {
        if (dialogStateRef.current?.open) return

        setNewCheckIn({
          checkInId: notificationData.checkInId,
          timestamp: notificationData.timestamp,
          status: notificationData.status,
          hasOutstandingOrFailedPayments: notificationData.hasOutstandingOrFailedPayments,
        })
        setCheckInCounter((prev) => prev + 1)
      }
    }

    return () => {
      channel.close()
    }
  }, [])

  // Only show when a site is selected
  if (!currentSite) return null

  // Hide on certain paths
  if (HIDDEN_PATHS.some((path) => location.pathname.includes(path))) return null

  const handleClick = () => {
    setCheckInCounter(0)
    pushDialog(ModalCheckIn, { title: 'checkIn' })
  }

  // Hide when dialog is open to avoid overlap
  const isVisible = !dialogState?.open

  return (
    <FloatButton
      onClick={handleClick}
      counter={checkInCounter}
      newCheckIn={newCheckIn}
      isVisible={isVisible}
    />
  )
})

export { CheckInFloatingButton }
export default CheckInFloatingButton
